import React from "react"

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M.661 6.356c-.215-.21-.215-.549 0-.758l.778-.759c.215-.21.563-.21.778 0l2.408 2.349 5.158-5.03c.215-.21.563-.21.778 0l.778.758c.215.21.215.549 0 .758L5.014 9.843c-.215.21-.563.21-.778 0L.661 6.356z"
    />
  </svg>
)

export default CheckIcon
